@if (wrapper && wrapper.isReady && !isHidden()) {
  <div [class]="getFormGroupClass()">
    <acc-form-label [name]="name" [wrapper]="wrapper" [size]="getSize()"/>
    <div class="input-group">
      <quill-editor [id]="name"
                    [modules]="getModules()"
                    [placeholder]="config.placeholder"
                    [sanitize]="true" format="html"
                    [dir]="getDir()"
                    [readOnly]="isViewOnly()"
                    [class.disabled]="isViewOnly()"
                    (onContentChanged)="accContentChanged($event)"
                    (onBlur)="accContentLeave($event)"
                    [ngModel]="editorModel"
                    [class.quill-editor-auto]="getSize()?.isAuto()"
                    [class.quill-editor-sm]="getSize()?.isSmall()"
                    [class.quill-editor-lg]="getSize()?.isLarge()"
                    [class.is-invalid]="isInvalid()">
      </quill-editor>
    </div>
    <acc-form-field-error [name]="name" [wrapper]="wrapper"></acc-form-field-error>
  </div>
}
